"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecretProofTransactionBodyBuilder = void 0;

var GeneratorUtils_1 = require("./GeneratorUtils");

var Hash256Dto_1 = require("./Hash256Dto");

var UnresolvedAddressDto_1 = require("./UnresolvedAddressDto");

var SecretProofTransactionBodyBuilder = /*#__PURE__*/function () {
  function SecretProofTransactionBodyBuilder(recipientAddress, secret, hashAlgorithm, proof) {
    _classCallCheck(this, SecretProofTransactionBodyBuilder);

    GeneratorUtils_1.GeneratorUtils.notNull(recipientAddress, 'recipientAddress is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(secret, 'secret is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(hashAlgorithm, 'hashAlgorithm is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(proof, 'proof is null or undefined');
    this.recipientAddress = recipientAddress;
    this.secret = secret;
    this.hashAlgorithm = hashAlgorithm;
    this.proof = proof;
  }

  _createClass(SecretProofTransactionBodyBuilder, [{
    key: "getRecipientAddress",
    value: function getRecipientAddress() {
      return this.recipientAddress;
    }
  }, {
    key: "getSecret",
    value: function getSecret() {
      return this.secret;
    }
  }, {
    key: "getHashAlgorithm",
    value: function getHashAlgorithm() {
      return this.hashAlgorithm;
    }
  }, {
    key: "getProof",
    value: function getProof() {
      return this.proof;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = 0;
      size += this.recipientAddress.getSize();
      size += this.secret.getSize();
      size += 2;
      size += 1;
      size += this.proof.length;
      return size;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);
      var recipientAddressBytes = this.recipientAddress.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, recipientAddressBytes);
      var secretBytes = this.secret.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, secretBytes);
      var proofSizeBytes = GeneratorUtils_1.GeneratorUtils.uint16ToBuffer(this.proof.length);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, proofSizeBytes);
      var hashAlgorithmBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.hashAlgorithm);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, hashAlgorithmBytes);
      var proofBytes = this.proof;
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, proofBytes);
      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var recipientAddress = UnresolvedAddressDto_1.UnresolvedAddressDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, recipientAddress.getSize());
      var secret = Hash256Dto_1.Hash256Dto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, secret.getSize());
      var proofSize = GeneratorUtils_1.GeneratorUtils.bufferToUint16(Uint8Array.from(byteArray));
      byteArray.splice(0, 2);
      var hashAlgorithm = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var proof = GeneratorUtils_1.GeneratorUtils.getBytes(Uint8Array.from(byteArray), proofSize);
      byteArray.splice(0, proofSize);
      return new SecretProofTransactionBodyBuilder(recipientAddress, secret, hashAlgorithm, proof);
    }
  }, {
    key: "createSecretProofTransactionBodyBuilder",
    value: function createSecretProofTransactionBodyBuilder(recipientAddress, secret, hashAlgorithm, proof) {
      return new SecretProofTransactionBodyBuilder(recipientAddress, secret, hashAlgorithm, proof);
    }
  }]);

  return SecretProofTransactionBodyBuilder;
}();

exports.SecretProofTransactionBodyBuilder = SecretProofTransactionBodyBuilder;